export const name = 'assetsInfoDialogController';
export default function assetsInfoDialogController($mdDialog){
    //noinspection BadExpressionStatementJS
    'ngInject';
    /* jshint validthis: true */

    let vm = this;

    vm.close = close;

    function close(){
        $mdDialog.hide();
    }
}
